import { GroupsManagement } from 'src/pages/GroupsManagement/GroupsManagement';
import { LoginPage } from 'src/pages/LoginPage';
import { ResetPage } from 'src/pages/ResetPage';
import { TablePage } from 'src/pages/TablePage';
import { routesEnum } from 'src/shared/const';
import { ProtectedRoute, PublicRoute } from 'src/shared/types';

export const publicRoutes: PublicRoute[] = [
  {
    path: routesEnum.LOGIN,
    element: <LoginPage />,
  },
  {
    path: routesEnum.RESET,
    element: <ResetPage />,
  },
];

export const protectedRoutes: ProtectedRoute[] = [
  {
    path: routesEnum.TABLE_ALIAS,
    element: <TablePage />,
  },
  {
    path: routesEnum.TABLE,
    element: <TablePage />,
  },
  {
    path: routesEnum.GROUPS,
    element: <GroupsManagement />,
  },
];
